export default __webpack_public_path__ + "static/media/ide.7b9fd910.png";